var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgManagerChatActive = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 25,
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.74669 18.4939L4.81829 18.2628C4.83872 18.1888 4.82151 18.1095 4.77226 18.0507C2.31617 15.215 1.80408 11.2656 3.4664 7.92965C5.02491 4.8007 8.2298 2.73976 11.8261 2.51485L12.1488 2.5H12.4988C16.502 2.5 20.1266 4.77275 21.7032 8.28457C23.2731 11.7999 22.4811 15.8765 19.6981 18.6309C16.983 21.3041 12.9001 22.2246 9.23782 21.0156L8.93799 20.9117C8.86508 20.8857 8.78464 20.8914 8.71614 20.9274L8.37135 21.0928C7.49141 21.5249 6.21981 21.9897 4.77877 22.4491C3.89451 22.7288 3.07959 21.8026 3.56018 20.9778C4.08215 20.0799 4.50777 19.2146 4.74669 18.4939ZM16.8373 9.5C17.2239 9.5 17.5373 9.8134 17.5373 10.2C17.5373 10.5866 17.2239 10.9 16.8373 10.9H8.19998C7.81338 10.9 7.49998 10.5866 7.49998 10.2C7.49998 9.8134 7.81338 9.5 8.19998 9.5H16.8373ZM15.6682 14.2C15.6682 13.8134 15.3548 13.5 14.9682 13.5H8.2C7.8134 13.5 7.5 13.8134 7.5 14.2C7.5 14.5866 7.8134 14.9 8.2 14.9H14.9682C15.3548 14.9 15.6682 14.5866 15.6682 14.2Z",
  fill: "#6467EF"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgManagerChatActive);
export default ForwardRef;